/** Fenêtre du bureau (`?aurelia_hub=2`) uniquement. L’icône installée ne passe pas ici. */

function stampHub2(input: RequestInfo | URL): boolean {
  const raw = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
  try {
    const url = new URL(raw, window.location.href);
    if (url.origin === window.location.origin) return true;
    return url.hostname.endsWith("aureliasuite.fr") && /\/api_suite(\/|$)|\/facturx\/api(\/|$)/.test(url.pathname);
  } catch {
    return false;
  }
}

function installHub2Fetch(): void {
  if (window.__facturxHub2Fetch) return;
  window.__facturxHub2Fetch = true;
  const native = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    if (!isFacturxHub2Desk() || !stampHub2(input)) return native(input, init);
    const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
    headers.set("X-Aurelia-Hub", "2");
    if (input instanceof Request) return native(new Request(input, { ...init, headers }));
    return native(input, { ...init, headers });
  };
}

function markFacturxHub2FromDesk(): void {
  try {
    if (window.parent === window) return;
    if (new URLSearchParams(window.location.search).get("aurelia_hub") === "2") {
      window.__facturxHub2 = true;
      installHub2Fetch();
    }
  } catch {
    /* onglet ou PWA : la connexion actuelle reste */
  }
}

markFacturxHub2FromDesk();

export function isFacturxHub2Desk(): boolean {
  return window.__facturxHub2 === true;
}

declare global {
  interface Window {
    __facturxHub2?: boolean;
    __facturxHub2Fetch?: boolean;
    __facturxHub2UserId?: string;
  }
}
